// Serviço de logging seguro que só exibe logs em desenvolvimento
const isDev = process.env.NODE_ENV !== "production";

/**
 * Logger seguro que só exibe logs em ambiente de desenvolvimento
 * Substitui console.log/error/warn no projeto
 */
export const logger = {
  debug: (message: string, ...args: unknown[]): void => {
    if (isDev) {
      console.debug(`[DEBUG] ${message}`, ...args);
    }
  },

  info: (message: string, ...args: unknown[]): void => {
    if (isDev) {
      console.info(`[INFO] ${message}`, ...args);
    }
  },

  warn: (message: string, ...args: unknown[]): void => {
    if (isDev) {
      console.warn(`[WARN] ${message}`, ...args);
    }
  },

  error: (message: string, ...args: unknown[]): void => {
    // Erros são importantes mesmo em produção, mas podemos remover dados sensíveis
    if (isDev) {
      console.error(`[ERROR] ${message}`, ...args);
    } else {
      // Em produção, logar apenas a mensagem de erro sem detalhes sensíveis
      console.error(`[ERROR] ${message}`);
    }
  },

  // Método para logar em produção quando realmente necessário
  // Use apenas para erros críticos que precisam ser vistos em produção
  critical: (message: string): void => {
    console.error(`[CRITICAL] ${message}`);
  },
};
